import type { PropsWithChildren } from 'react';
import React from 'react';

import { cn } from '@change/ds-utils';

import { Footer } from './components/Footer';
import { Header } from './components/Header';
import type { DefaultLayoutProps } from './shared/types';

export const Layout = ({
	hideHeader,
	hideFooter,
	suppressHydrationWarning,
	children,
}: PropsWithChildren<DefaultLayoutProps> & { suppressHydrationWarning?: boolean }): React.JSX.Element | null => {
	if (hideFooter && hideHeader) {
		return (
			<div
				// needed so that App can focus fallback on it
				data-maincontent-principal
				className="h-full"
				role="main"
				suppressHydrationWarning={suppressHydrationWarning}
			>
				{children}
			</div>
		);
	}

	return (
		<>
			{/* https://philipwalton.com/articles/normalizing-cross-browser-flexbox-bugs/ */}
			<div suppressHydrationWarning={suppressHydrationWarning}>
				{!hideHeader && <Header className="shrink-0" />}
				<div
					// needed so that App can focus fallback on it
					data-maincontent-principal
					// this is to avoid blank space after the footer
					// using flex:1 on the body currently doesn't work because of the banners being outside of the layout
					// and that can sometimes result in double scrollbars on desktop
					// 300px come from manually measuring the height of the footer and header
					// (not great but better than nothing for now)
					className={cn(hideFooter ? '' : 'min-h-[calc(100vh_-_300px)]')}
					data-qa="page-content"
					role="main"
				>
					{children}
				</div>
				{!hideFooter && <Footer className="mb-20 shrink-0 md:mb-8" />}
			</div>
		</>
	);
};

export const HEADER_HEIGHT = 60;
